import ExcelJs from 'exceljs';

const exportExcel = async ({ data, filename }) => {
  const workbook = new ExcelJs.Workbook();
  data.map((sheetData, index) => {
    const sheet = workbook.addWorksheet(
      sheetData.sheetName ?? `Sheets${index + 1}`
    );
    return sheet.addTable({
      name: sheetData.tableName ?? `Table${index + 1}`,
      ref: 'A1',
      headerRow: true,
      columns: sheetData.thead.map((s) => {
        return { name: s };
      }),
      rows: sheetData.tbody,
    });
  });
  const buffer = await workbook.xlsx.writeBuffer();
  const link = document.createElement('a');
  const blob = new Blob([buffer], {
    type: 'application/octet-stream',
  });
  link.download = `${filename}.xlsx`;
  link.href = URL.createObjectURL(blob);
  link.click();
};

export default exportExcel;
